module.exports = __webpack_public_path__ + "static/GilroyAlt-Bold-6de71cb5e4eebe602e00a62eef69b5d1.woff";